import React, { useEffect, useRef, useState } from "react"
import { HugoStateApi, useButton, useTemplateEngine } from "../../hugo"
import { Cell, Paper, Row, Wall } from "../../ui"
import useBreakout from "./useBreakout"
import GameStats from "./GameStats.styled"
import startHugo from "./start.hugo"
import gameoverHugo from "./gameover.hugo"
import wonHugo from "./won.huho"
import instructionImage from "./assets/instruction.png"
import { useNavigate } from "react-router-dom"

type Props = {
    hugoApi: HugoStateApi
}

enum PlayState {
    Idle = 'idle',
    Playing = 'playing',
    Won = 'won',
    Lost = 'lost',
}
const tickRate = 24

const Breakout: React.FC<Props> = ({ hugoApi }) => {
    const render = useTemplateEngine()
    const [playState, setPlayState] = useState<PlayState>(PlayState.Idle)
    const playStateRef = useRef(playState)
    const navigate = useNavigate()

    const [game, state] = useBreakout({
        hugoApi,
        tickRate,
        onGameOver: () => {
            setPlayState(PlayState.Lost)
        },
        onWon: () => {
            setPlayState(PlayState.Won)
        },
    })
    const [startButton] = useButton({
        label: 'New Game',
        onClick: () => {
            if (playStateRef.current === PlayState.Idle) {
                setPlayState(PlayState.Playing)
            }
        },
        position: { x: 12, y: 11 },
        visible: true,
        condensed: true,
    })
    const [restartButton] = useButton({
        label: 'Play Again',
        onClick: () => {
            if (playStateRef.current === PlayState.Lost) {
                setPlayState(PlayState.Playing)
            }
        },
        position: { x: 11, y: 5 },
        visible: true,
        condensed: true,
    })
    const [backButton] = useButton({
        label: '←',
        onClick: () => {
            if (playStateRef.current !== PlayState.Playing) {
                navigate('/', { state: 'hugo' })
            }
        },
        position: { x: 2, y: 0 },
        visible: true,
        condensed: true,
    })

    useEffect(() => {
        switch (playState) {
            case PlayState.Idle:
                hugoApi.output(render(startHugo), { append: false, plugins: [startButton, backButton] })
                break
            case PlayState.Playing:
                game.start()
                break
            case PlayState.Lost:
                hugoApi.output(render(gameoverHugo, { score: `${state.score}` }), { append: false, plugins: [restartButton, backButton] })
                break;
            case PlayState.Won:
                hugoApi.output(render(wonHugo, { score: `${state.score}` }), { append: false, plugins: [backButton] })
                break;
        }
        playStateRef.current = playState
    }, [playState])

    return (
        <Wall>
            <Paper>
                <Row $height={2.6} $hueRotate={90} $contrast={90} $brightness={98} $saturate={120}>
                    <Cell $width={1.8} >
                        <h1>Breakout HUGO</h1>
                        {playState === PlayState.Won ? (
                            <>
                                <p>WINNER WINNER WINNER</p>
                                <p>WINNER WINNER WINNER</p>
                                <p>WINNER WINNER WINNER</p>
                                <p>WINNER WINNER WINNER</p>
                                <p>WINNER WINNER WINNER</p>
                                <p>WINNER WINNER WINNER</p>
                                <p>WINNER WINNER WINNER</p>
                                <p>WINNER WINNER WINNER</p>
                                <p>WINNER WINNER WINNER</p>
                            </>
                        ) : <img src={instructionImage} style={{ width: '100%', margin: '0', opacity: 0.8 }} />}

                    </Cell>
                </Row>
            </Paper>
            <Paper $rotate={5}>
                <Row $height={1.8} $contrast={90} $brightness={100} $saturate={120}>
                    <GameStats $width={1.6} >
                        {playState === PlayState.Won ? (
                            <>
                                <p>WINNER WINNER</p>
                                <p>WINNER WINNER</p>
                                <p>WINNER WINNER</p>
                                <p>Score: {state.score}</p>
                            </>
                        ) : (playState === PlayState.Lost ? (
                            <>
                                <p>Lives: {[...Array(state.lives)].map((e, i) => <span key={i}>● </span>)}</p>
                                <p>Level: {state.currentLevel !== null ? state.currentLevel + 1 : '-'}</p>
                                <p>Score: {state.score}</p>
                            </>
                        ) : (
                            <>
                                <p>Lives: {[...Array(state.lives)].map((e, i) => <span key={i}>● </span>)}</p>
                                <p>Level: {state.currentLevel !== null ? state.currentLevel + 1 : '-'}</p>
                                <p>Time: {Math.floor(state.tick * (1 / tickRate))}</p>
                                <p>Score: {state.score}</p>
                            </>
                        ))}

                    </GameStats>
                </Row>
            </Paper>
        </Wall>
    )
}

export default Breakout